import React, { FC } from 'react';
import styled from 'styles/styled-components';

import { clock, shield, standardSolution, thumbnailUp } from '../Images';

import SVGIcon from 'components/SVGIcon/SVGIcon';

import { FormattedMessage } from 'react-intl';
import { RouteComponentProps, RouteProps, withRouter } from 'react-router-dom';
import { arrowRightButton } from '../../FarmToTablePage/Images';
import messages from '../messages';
import { MainButton } from './CommonComponents';
import { SectionTitle, SectionTitleBox } from './ProductsSource';
import media from 'utils/mediaStyle';

const SectionContainer = styled.div`
  width: 100%;
  background: #ffffff;
  padding: 20px 0px;
  ${media.lg`
    padding: 40px 0px;
    `}
`;

const SectionWrapper = styled.div`
  max-width: 1312px;
  width: 100%;
  background: #f7f5ee;
  border-radius: 24px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  @media (max-width: 991px) {
    border-radius: 0px;
  }
`;

const SectionContentWrapper = styled.div`
  width: 100%;
  margin-top: 80px;
  margin-bottom: -240px;
  @media (max-width: 991px) {
    margin-top: 40px;
    margin-bottom: -95px;
    padding: 0 16px;
  }
`;

const SectionImage = styled.div`
  background: url(${standardSolution});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  // height: 100%;
  padding-top: 79%;
`;

const BenefitCardWrapper = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  gap: 20px;
  @media (max-width: 991px) {
    flex-direction: column;
    gap: 0px;
  }
`;

const BenefitCard = styled.div`
  border-radius: 16px;
  background: #fff;
  box-shadow: 4px 16px 32px 0 rgba(177, 146, 38, 0.15);
  padding: 24px 17px;
  gap: 4px;
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  @media (max-width: 991px) {
    border-radius: 0px;
    padding: 16px;
    &:first-child {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    &:last-child {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
    &:not(:last-child):after {
      content: '';
      width: calc(100% - 32px);
      height: 1px;
      background: #eaebea;
      position: absolute;
      left: 16px;
      bottom: 0px;
    }
  }
`;

const BenefitCardTitleBox = styled.div`
  @media (max-width: 991px) {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

const BenefitCardTitle = styled.div`
  color: #3c9041;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin-top: 12px;
  @media (max-width: 991px) {
    font-size: 16px;
    line-height: 20px;
    text-align: left;
    margin-top: 0px;
  }
`;

const BenefitCardDescription = styled.div`
  color: #000;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  @media (max-width: 991px) {
    font-size: 14px;
    line-height: 18px;
    text-align: left;
  }
`;

const MainButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0px 40px;
  ${MainButton} {
    box-shadow: none;
    @media (max-width: 767px) {
      font-size: 16px;
    }
  }
`;

const SVGIconWrapper = styled(SVGIcon)`
  img {
    @media (max-width: 767px) {
      width: 19px;
    }
  }
`;

const StandardSolution: FC<RouteProps & RouteComponentProps> = ({ history }) => {
  const lang = localStorage.getItem('lang') || 'vi';
  const loggedIn = !!localStorage.getItem('token');
  const data = [
    {
      id: 1,
      icon: thumbnailUp,
      title: lang === 'vi' ? 'Tiết kiệm chi phí' : 'Saving costs',
      description:
        lang === 'vi'
          ? 'Đa dạng quy cách đóng gói, mua theo thùng càng lợi, phù hợp nhu cầu lớn và tối ưu ngân sách.'
          : 'Saving costs',
    },
    {
      id: 2,
      icon: shield,
      title: lang === 'vi' ? 'Tối ưu vận hành' : 'Optimizing Operation',
      description:
        lang === 'vi'
          ? 'Công nghệ tạo bọt hiện đại, sử dụng được nhiều lượt hơn, giúp tiết kiệm và nâng cao hiệu quả cho doanh nghiệp.'
          : 'Saving costs',
    },
    {
      id: 3,
      icon: clock,
      title:
        lang === 'vi'
          ? 'Sản phẩm sinh học, tự phân hủy đến 60% trong 2 năm, góp phần giảm đáng kể rác thải nhựa ra môi trường.'
          : 'Saving costs',
    },
  ];

  const dataDistribute = [
    {
      id: 1,
      icon: thumbnailUp,
      title: lang === 'vi' ? 'Chất lượng Nhật Bản' : 'Japanese-Quality Standards',
      description:
        lang === 'vi'
          ? 'Nguyên liệu được chọn lọc kỹ càng, giữ trọn độ tươi ngon và đồng đều cho doanh nghiệp.'
          : 'Carefully selected ingredients, ensuring consistent quality and freshness for your business.',
    },
    {
      id: 2,
      icon: shield,
      title: lang === 'vi' ? 'An toàn vệ sinh thực phẩm' : 'Food Safety Assurance',
      description:
        lang === 'vi'
          ? 'Rau củ nấm thu hoạch từ Đà Lạt, có chứng nhận vệ sinh an toàn, giao tận tay không qua trung gian.'
          : 'Vegetables and mushrooms harvested from Da Lat, safety-certified and delivered directly with no intermediaries.',
    },
    {
      id: 3,
      icon: clock,
      title: lang === 'vi' ? 'Tối ưu vận hành' : 'Operational Efficiency',
      description:
        lang === 'vi'
          ? 'Sản phẩm sơ chế sẵn, tiện lợi cho chuỗi F&B, giúp tiết kiệm thời gian chuẩn bị và bếp vận hành hiệu quả hơn.'
          : 'Pre-processed products designed for F&B chains, reducing prep time and improving kitchen efficiency.',
    },
  ];
  return (
    <SectionContainer>
      <SectionWrapper>
        <SectionContentWrapper>
          <SectionTitleBox>
            {lang === 'vi' ? (
              <SectionTitle highLight>
                Giải pháp chuẩn <SectionTitle>&nbsp;cho doanh nghiệp F&B</SectionTitle>
              </SectionTitle>
            ) : (
              <SectionTitle highLight>
                A Standardized Solution
                <SectionTitle>&nbsp;for F&B Businesses</SectionTitle>
              </SectionTitle>
            )}
          </SectionTitleBox>
          {!loggedIn && (
            <MainButtonWrapper>
              <MainButton type="primary" style={{ background: '#43A047' }} onClick={() => history.push('/contact-us')}>
                <FormattedMessage {...messages.createPurchaseAccount} />
                <SVGIcon src={arrowRightButton} />
              </MainButton>
            </MainButtonWrapper>
          )}
          <BenefitCardWrapper>
            {dataDistribute?.map((data) => (
              <BenefitCard key={data?.id}>
                <BenefitCardTitleBox>
                  <SVGIconWrapper src={data?.icon} />
                  <BenefitCardTitle>{data?.title}</BenefitCardTitle>
                </BenefitCardTitleBox>
                <BenefitCardDescription>{data?.description}</BenefitCardDescription>
              </BenefitCard>
            ))}
          </BenefitCardWrapper>
        </SectionContentWrapper>
        <SectionImage />
      </SectionWrapper>
    </SectionContainer>
  );
};

export default withRouter(StandardSolution);
